const ArrowBottomIcon = (props: any) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M8 11.0006L3.75732 6.758L5.17154 5.34375L8 8.1722L10.8284 5.34375L12.2426 6.758L8 11.0006Z'
        fill='#3C4257'
        fillOpacity='0.5'
      />
    </svg>
  );
};

export default ArrowBottomIcon;
